import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// import {tryCatch} from 'rxjs/internal-compatibility';

@Component({
  selector: 'app-protected-information',
  templateUrl: './protected-information.component.html',
  styleUrls: ['./protected-information.component.scss']
})
export class ProtectedInformationComponent implements OnInit {
  displayPrivacyModal = false;
  constructor(
    translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

  // protected readonly tryCatch = tryCatch;
}
